var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"align-center justify-center",attrs:{"value":_vm.value,"persistent":true,"close-on-content-click":false}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }